import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Security(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Security", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27 45.75a25.595 25.595 0 0 0 11.931-7.718c9.356-10.826 6.477-25.904 6.144-27.532a28.9 28.9 0 0 1-9.036-2.25 30.6 30.6 0 0 1-9.039-6 30.6 30.6 0 0 1-9.035 6 28.9 28.9 0 0 1-9.036 2.25c-.337 1.628-3.216 16.706 6.14 27.532A25.596 25.596 0 0 0 27 45.75Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27 42a21.929 21.929 0 0 1-9.1-6.203c-6.34-7.314-6.171-17.204-5.697-21.662a32.879 32.879 0 0 0 7.232-2.153A33.916 33.916 0 0 0 27 7.5a33.915 33.915 0 0 0 7.565 4.482 32.873 32.873 0 0 0 7.232 2.152c.475 4.459.643 14.349-5.696 21.662A21.931 21.931 0 0 1 27 42Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M30.75 23.25a.75.75 0 0 1-.75-.75v-3a2.25 2.25 0 0 0-2.25-2.25h-1.5A2.25 2.25 0 0 0 24 19.5v3a.75.75 0 1 1-1.5 0v-3a3.754 3.754 0 0 1 3.75-3.75h1.5a3.754 3.754 0 0 1 3.75 3.75v3a.75.75 0 0 1-.75.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M21 21.75h12v7.5l-2.25 3h-7.5l-2.25-3v-7.5Z", fill: theme.vars.palette.secondary.dark }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.198 27.517 25.5 29.25h3l-.698-1.733a1.5 1.5 0 1 0-1.604 0ZM14.25 20.25h-9a3 3 0 0 0-3 3v19.5a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-19.5a3 3 0 0 0-3-3Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M3.75 23.25h12v19.5h-12v-19.5Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.25 14.25a.745.745 0 0 1-.584-.278A5.014 5.014 0 0 0 9.75 12a5.015 5.015 0 0 0-3.917 1.972.75.75 0 0 1-1.166-.944A6.572 6.572 0 0 1 9.75 10.5a6.574 6.574 0 0 1 5.083 2.528.75.75 0 0 1-.583 1.222Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.374 16.5a.75.75 0 0 1-.609-.311A2.538 2.538 0 0 0 9.75 15a2.537 2.537 0 0 0-2.016 1.189.749.749 0 1 1-1.217-.878A4.04 4.04 0 0 1 9.75 13.5a4.04 4.04 0 0 1 3.234 1.811.75.75 0 0 1-.609 1.189Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.75 18a.75.75 0 0 1-.008-1.5h.008a.75.75 0 1 1 0 1.5Zm4.5 18.75a.75.75 0 0 1-.75-.75v-3a3.63 3.63 0 0 0-.335-1.528.75.75 0 0 1 1.36-.634c.313.677.475 1.415.475 2.162v3a.75.75 0 0 1-.75.75Zm-9 0A.75.75 0 0 1 4.5 36v-3a5.256 5.256 0 0 1 5.25-5.25 5.07 5.07 0 0 1 2.162.476.75.75 0 1 1-.634 1.358c-.478-.222-1-.336-1.528-.334A3.755 3.755 0 0 0 6 33v3a.75.75 0 0 1-.75.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.75 38.25A.75.75 0 0 1 9 37.5V33a.75.75 0 1 1 1.5 0v4.5a.75.75 0 0 1-.75.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 37.5a.75.75 0 0 1-.75-.75V33a1.5 1.5 0 1 0-3 0v.75a.75.75 0 1 1-1.5 0V33a3 3 0 0 1 6 0v3.75a.75.75 0 0 1-.75.75Zm-4.5 0a.75.75 0 0 1-.75-.75V36a.75.75 0 1 1 1.5 0v.75a.75.75 0 0 1-.75.75Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Security.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Security"
};
validateTidalLicense();
export {
  Security
};
//# sourceMappingURL=Security.js.map
